export default "__VITE_ASSET__7ffe307f__"